// Exportar la lista de casos a CSV.
//
// El boton de exportar ya estaba puesto, pero no exportaba nada: react-admin
// hace `exporter && exporter(data, ...)` y el ListContextProvider de
// CofidisCaseList no traia ningun `exporter`. O sea que al pulsarlo se leia la
// coleccion entera, se pagaba, y el resultado se tiraba.
// (Comprobado en node_modules/ra-ui-materialui/.../ExportButton.js.)
//
// «La coleccion entera» y no «1.000 documentos»: el `perPage: 1000` que manda
// ExportButton no llega a Firestore. react-admin-firebase hace `getDocs` de
// toda la coleccion en RefreshResource y luego corta la pagina en memoria
// (dist/src/providers/queries/GetList.js:73-75). Son 2.623 lecturas por clic,
// medido con count() el 07/09.
//
// Separador `;` y BOM al principio porque el Excel en espanol abre asi los CSV
// sin tener que importarlos a mano.

const texto = (v) => (v === null || v === undefined ? '' : String(v));

/** Fecha legible, venga como Timestamp de Firestore, Date o cadena. */
export const fecha = (v) => {
  if (!v) return '';
  const d = typeof v?.toDate === 'function' ? v.toDate()
    : v instanceof Date ? v
      : new Date(v);
  if (Number.isNaN(d.getTime())) return texto(v);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${d.getFullYear()}`;
};

const nombreCompleto = (t) => [t?.nombre, t?.apellidos].map(texto).filter(Boolean).join(' ');

const telefono = (c) => texto(
  c?.primerTitular?.telefono || c?.primerTitular?.movil
  || c?.primerTitular?.telefonoFijo || c?.phone || c?.mobile || c?.movil,
);

// Las mismas columnas que enseña la lista, mas el numero de caso y los DNI,
// que en la tabla estan ocultos pero en una hoja de calculo son justo por lo
// que se busca. Si operaciones las quiere distintas, se cambian aqui.
export const COLUMNAS = [
  ['Nº de caso', (c) => texto(c.caseNumber)],
  ['Primer titular', (c) => nombreCompleto(c.primerTitular)],
  ['DNI primer titular', (c) => texto(c.primerTitular?.dni)],
  ['Segundo titular', (c) => nombreCompleto(c.segundoTitular)],
  ['DNI segundo titular', (c) => texto(c.segundoTitular?.dni)],
  ['Teléfono', telefono],
  ['Nº de pagas', (c) => texto(c.numeroPagas)],
  ['Estado', (c) => texto(c.status)],
  ['Fecha de registro', (c) => fecha(c.registeredDate)],
  ['Operaciones', (c) => texto(c.operacionesAgent)],
  ['Comercial', (c) => texto(c.comercialAgent)],
];

/** Una celda de CSV: se entrecomilla solo si hace falta. */
export const celda = (v) => {
  const s = texto(v);
  return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const aCsv = (registros, columnas = COLUMNAS) => {
  const filas = [columnas.map(([etiqueta]) => celda(etiqueta)).join(';')];
  (registros || []).forEach((r) => {
    filas.push(columnas.map(([, valor]) => celda(valor(r || {}))).join(';'));
  });
  return filas.join('\r\n');
};

export const nombreFichero = (hoy = new Date()) => {
  const dd = String(hoy.getDate()).padStart(2, '0');
  const mm = String(hoy.getMonth() + 1).padStart(2, '0');
  return `casos-cofidis-${hoy.getFullYear()}-${mm}-${dd}.csv`;
};

/** Lanza la descarga en el navegador. */
export const descargar = (csv, nombre) => {
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

/** Lo que espera react-admin como `exporter`. */
export const exportarCasos = (registros) => {
  descargar(aCsv(registros), nombreFichero());
};
